<template>
  <material-card
    :title="$t('components.claims.claim_history_table')"
    icon="description"
  >
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :showSelect="false"
      @error="error = $event"
      :rowActions="rowActions"
    ></pbas-data-table>
    <claim-history-details-dialog
      :claimHistoryItem="selectedItem"
      :model="detailsDialog"
      @close="detailsDialog = false"
    />
    <error-handler :error="error"></error-handler>
  </material-card>
</template>
<script>
import { mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import ClaimHistoryHeaders from "@/headers/iSeriesClaimHistory";
import ErrorHandler from "@/components/ErrorHandler";
import ClaimHistoryDetailsDialog from "@/components/iSeriesClaims/ClaimHistoryDetailsDialog";
export default {
  components: {
    ErrorHandler,
    ClaimHistoryDetailsDialog,
  },
  props: ["filter"],
  data() {
    return {
      error: null,
      provider: undefined,
      rowActions: [
        {
          name: "viewItem",
          icon: "visibility",
          title: "components.membersmanagementtable.details",
          handler: (item) => {
            this.selectedItem = item;
            this.detailsDialog = true;
          },
        },
      ],
      detailsDialog: false,
      selectedItem: null,
    };
  },
  computed: {
    ...mapGetters("common", {
      settings: "settings",
    }),
  },
  watch: {
    filter: {
      handler(v) {
        this.provider.filter = v;
        this.$refs.table.getDataAsync();
      },
    },
  },
  mounted() {
    this.provider = new ODataProvider(
      this.$axiosHttp,
      this.settings.APIURL +
        "claim-history-summary",
      ClaimHistoryHeaders
    );
  },
};
</script>
